var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"color-scheme-card",class:{
    'color-scheme-card--selected': _vm.isSelected
  },style:(_vm.previewStyle),attrs:{"role":"button"},on:{"click":_vm.select}},[_c('div',{staticClass:"color-scheme-card__letter"},[_vm._v("A")]),(_vm.isSelected)?_c('div',{staticClass:"color-scheme-card__checkmark"},[_c('Icon',{attrs:{"icon":"CheckIcon","size":"12"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }